import { createVanIconComponent } from "./van"

const Clear = createVanIconComponent("clear")
export default Clear
